<template>
  <div class="ele-body">
    <el-card shadow="never" v-loading="loading" body-style="padding-bottom: 0;">
      <el-row :gutter="15">
        <el-col :md="8" style="margin-bottom: 15px">
          <!-- 操作按钮 -->
          <div class="ele-table-tool ele-table-tool-default">
            <el-button @click="add" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加 </el-button>
            <el-button @click="edit" type="warning" icon="el-icon-edit" class="ele-btn-icon" :disabled="!current" size="small">修改 </el-button>
            <el-button
              @click="remove"
              type="danger"
              icon="el-icon-delete"
              class="ele-btn-icon"
              :disabled="!current || current.parentId == 0"
              size="small"
              >删除
            </el-button>
            <el-button @click="showImportDepart = true" type="primary" icon="el-icon-upload" class="ele-btn-icon" :disabled="!current" size="small"
              >批量导入</el-button
            >
          </div>
          <!-- 机构列表 -->
          <div class="org-tree-group">
            <el-tree
              ref="orgTree"
              :data="data"
              :props="{ label: 'departmentName' }"
              :expand-on-click-node="false"
              node-key="id"
              :default-expand-all="true"
              @node-click="choose"
              highlight-current
            />
          </div>
        </el-col>
        <el-col :md="16" style="margin-bottom: 15px">
          <div class="teacher-group">
            <!--            <el-checkbox-group v-model="teacherIds">-->
            <!--              <el-checkbox border v-for="item in teacherList" :key="item.id" :label="item.id">{{item.teacherName}}</el-checkbox>-->
            <!--            </el-checkbox-group>-->
            <el-transfer
              filterable
              filter-placeholder="请输入教师姓名"
              v-model="teacherIds"
              :data="teacherList"
              :props="{ key: 'id', label: 'teacherName' }"
              :titles="['未调教师', '该部门教师']"
              :button-texts="['调出部门', '调入部门']"
              @change="fenPei"
            >
              <span slot-scope="{ option }">{{ option.teacherName }}</span>
            </el-transfer>
          </div>
          <!--          <div class="subcheck">-->
          <!--            <el-button @click="subCheck" type="primary" icon="el-icon-check" class="ele-btn-icon" size="medium">提交</el-button>-->
          <!--          </div>-->
        </el-col>
      </el-row>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog
      :title="editForm.id ? '修改机构' : '添加机构'"
      :visible.sync="showEdit"
      width="600px"
      @closed="editForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="82px">
        <el-row :gutter="15">
          <el-col :sm="12">
            <el-form-item label="上级机构:" prop="parentId">
              <treeselect
                v-model="editForm.parentId"
                :options="organizationList"
                placeholder="请选择上级机构"
                :defaultExpandLevel="4"
                :normalizer="
                  (d) => {
                    return { id: d.id, label: d.departmentName };
                  }
                "
              />
            </el-form-item>
            <el-form-item label="机构名称:" prop="departmentName">
              <el-input v-model="editForm.departmentName" placeholder="请输入机构名称" clearable />
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="排序号:" prop="orderNum">
              <el-input-number
                v-model="editForm.orderNum"
                controls-position="right"
                :min="0"
                placeholder="请输入排序号"
                class="ele-fluid ele-text-left"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="save(editForm.id)">保存</el-button>
      </div>
    </el-dialog>
    <!--批量分配部门教师-->
    <el-dialog
      title="批量分配部门教师"
      :visible.sync="showImportDepart"
      width="440px"
      :destroy-on-close="true"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <el-upload
        v-loading="uploadLoading"
        :action="$http.defaults.baseURL + '/depart/departmentBatchImportTeacher'"
        accept=".xls,.xlsx"
        :headers="$http.defaults.headers.common"
        :data="fileParam"
        :before-upload="() => (uploadLoading = true)"
        class="ele-block"
        :on-success="uploadInfoSuccess"
        :on-error="() => (uploadLoading = false)"
        :show-file-list="false"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或 <em>点击上传</em></div>
        <div class="el-upload__tip ele-text-center" slot="tip">
          只能上传xls、xlsx文件，
          <el-link type="primary" :underline="false" :href="authTemplate" download style="vertical-align: baseline">下载模板 </el-link>
        </div>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
  import Qs from 'qs';
  import Treeselect from '@riophae/vue-treeselect'; // 下拉树
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  import { getAllDepartList, addDepart, updateDepart, deleteDepart, getDepartmentTeacherList, departmentBatchAddTeacher } from '@/config/api'; //获取部门列表

  export default {
    name: 'DeptTeacher',
    components: { Treeselect },
    data() {
      return {
        loading: true, // 加载状态
        data: [], // 列表数据
        where: {}, // 搜索条件
        current: null, // 选中数据
        showEdit: false, // 是否显示表单弹窗
        editForm: {}, // 表单数据
        editRules: {
          // 表单验证规则
          departmentName: [{ required: true, message: '请输入机构名称', trigger: 'blur' }],
          orderNum: [{ required: true, message: '请输入排序号', trigger: 'blur' }],
          parentId: [{ required: true, message: '请选择上级部门', trigger: 'change' }],
        },
        organizationList: [], // 全部部门
        teacherList: [], //
        teacherIds: [], //选中的老师id数组
        departmentId: null,
        authTemplate: 'https://hdsys.oss-cn-beijing.aliyuncs.com/hdjxt/template/1630632258302/部门教师信息.xlsx',
        showImportDepart: false,
        uploadLoading: false, // 导入加载状态
        fileParam: {
          departmentId: '',
        },
      };
    },
    mounted() {
      this.query();
    },
    methods: {
      /* 查询 */
      query() {
        this.loading = true;
        getAllDepartList(this.where).then((res) => {
          this.loading = false;
          if (res.data.resCode == 200) {
            this.data = this.$util.toTreeData(res.data.data, 'id', 'parentId');
            setTimeout(() => {
              this.choose(this.data[0]);
            }, 100);
            if (Object.keys(this.where).length === 0) this.organizationList = this.data;
          } else {
            this.$message.error(res.data.resMsg || '获取数据失败');
          }
        });
      },
      /* 选择数据 */
      choose(row) {
        if (row != null) {
          this.current = row;
          this.$refs.orgTree.setCurrentKey(row.id);
          this.departmentId = row.id;
          this.fileParam.departmentId = row.id;
          this.queryTeacherList(row.id);
          // let data = {departmentId:row.id}
          // getDepartmentTeacherList(data).then((res) => {
          //   if(res.data.resCode == 200){
          //     this.teacherList = res.data.data
          //     let checked = []
          //     res.data.data.map(function (res){
          //       if(res.checked){
          //         checked.push(res.id);
          //       }
          //     })
          //     this.teacherIds = checked
          //   }else {
          //     this.$message.error(res.data.resMsg || '获取数据失败');
          //   }
          // })
        } else {
          this.current = null;
        }
      },
      // 查询老师列表
      queryTeacherList(departmentId) {
        let data = { departmentId: departmentId };
        getDepartmentTeacherList(data).then((res) => {
          if (res.data.resCode == 200) {
            this.teacherList = res.data.data;
            let checked = [];
            res.data.data.map(function(res) {
              if (res.checked) {
                checked.push(res.id);
              }
            });
            this.teacherIds = checked;
          } else {
            this.$message.error(res.data.resMsg || '获取数据失败');
          }
        });
      },
      // 添加显示编辑
      add() {
        this.editForm.parentId = this.current.id;
        this.showEdit = true;
      },
      /* 显示编辑 */
      edit() {
        this.editForm = Object.assign({}, this.current, {
          parentId: this.current.parentId || null,
        });
        this.showEdit = true;
      },
      /* 保存编辑 */
      save(deptID) {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            if (deptID == undefined) {
              // 添加部门
              addDepart(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.query();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            } else {
              // 更改部门
              updateDepart(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.query();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      /* 删除 */
      remove() {
        this.$confirm('确定要删除选中的机构吗?', '提示', {
          type: 'warning',
        }).then(() => {
          const loading = this.$loading({ lock: true });
          let data = {
            id: this.current.id,
            state: -1,
          };
          data = Qs.stringify(data);
          deleteDepart(data).then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.query();
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        });
      },
      // 提交选中的老师
      // subCheck(){
      //   let data = new FormData()
      //   data.append('departmentId',this.departmentId);
      //   data.append('teacherIds',this.teacherIds);
      //   departmentBatchAddTeacher(data).then((res) => {
      //     if(res.data.resCode == 200){
      //       this.$message({type: 'success', message: '提交成功'});
      //     }else{
      //       this.$message.error(res.data.resMsg);
      //     }
      //   })
      // },
      fenPei() {
        let data = new FormData();
        data.append('departmentId', this.departmentId);
        data.append('teacherIds', this.teacherIds);
        departmentBatchAddTeacher(data).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '提交成功' });
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 批量导入权限成功
      uploadInfoSuccess(res) {
        this.uploadLoading = false;
        if (res.resCode == '200') {
          this.showImportDepart = false;
          this.$message({ type: 'success', message: res.resMsg });
          this.queryTeacherList(this.departmentId);
        } else if (res.resCode == '5001') {
          const url = res.resMsg;
          this.$confirm('是否下载本次导入失败的记录', '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              window.open(url);
              this.query();
              this.showImportDepart = false;
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '下载失败',
              });
              this.showImportDepart = false;
            });
        } else {
          this.query();
          this.$message.error(res.resMsg);
        }
      },
    },
  };
</script>

<style scoped>
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(100vh - 220px);
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 40px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
  .ele-table-tool {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
  /deep/ .el-transfer {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /deep/ .el-transfer-panel {
    width: 36%;
  }
  /deep/ .el-transfer-panel__body {
    height: calc(100vh - 225px);
  }
  /deep/ .el-transfer-panel__list {
    height: calc(100vh - 225px);
  }
  .subcheck {
    text-align: end;
    margin-top: 15px;
  }
  /*.el-checkbox-group{*/
  /*  margin-top: 5px;*/
  /*  display: flex;*/
  /*  justify-content: flex-start;*/
  /*  flex-wrap: wrap;*/
  /*}*/
  /*.el-checkbox{*/
  /*  margin-top: 5px;*/
  /*  margin-left: 10px;*/
  /*}*/
  /*/deep/ .el-checkbox.is-bordered.el-checkbox--medium {*/
  /*  width: 95px;*/
  /*  padding: 7px 20px 7px 10px;*/
  /*  border-radius: 4px;*/
  /*  height: 36px;*/
  /*  display: flex;*/
  /*  justify-content: center;*/
  /*  align-items: center;*/
  /*}*/
  .ele-block {
    display: flex !important;
    flex-flow: column !important;
    align-items: center !important;
  }
  @media screen and (max-width: 1366px) {
    /deep/ .el-transfer-panel {
      width: 30%;
    }
    /deep/ .el-transfer {
      width: 100%;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    }
  }
</style>
